import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Lets any page ask AppComponent to sign out with the app's full sign-out
 * (Firebase, push topics, sockets, stored state, v2 session), then go to `landing`.
 */
@Injectable({ providedIn: 'root' })
export class SignOutService {
  private readonly requests = new Subject<string>();
  readonly requests$ = this.requests.asObservable();

  signOut(landing = 'new-login'): void {
    this.requests.next(landing);
  }
}
